export const config = (props) => {
  const { roleListForCombo, enums, kjsList, municipalityList } = props || {},
    { Role } = enums || {};

  return {
    fields: [
      {
        key: 1,
        name: 'firstName',
        type: 'text',
        component: 'input',
      },
      {
        key: 2,
        name: 'lastName',
        type: 'text',
        component: 'input',
      },
      {
        key: 3,
        name: 'role',
        type: 'autocomplete',
        optionList: roleListForCombo || [],
        getOptionLabel: (role) => (role && Role[role.roleName]?.text) || '',
      },
      {
        key: 4,
        name: 'municipality',
        type: 'autocomplete',
        optionList: municipalityList || [],
        getOptionLabel: (municipality) => municipality?.name || '',
      },
      {
        key: 5,
        name: 'kjs',
        type: 'autocomplete',
        optionList: kjsList || [],
        getOptionLabel: (kjs) => kjs?.name || '',
      },
    ],
  };
};
